import { APIClient } from "./api_helper";

import * as url from "./url_helper";

import axios from 'axios';  // Importar axios al inicio del archivo



const api = new APIClient();



// Diagnosticos

export const getDiagnosticos = () => api.get(url.BASE_DIAGNOSTICOS);



// Siscotel

export const createEventResult = (siscotel) =>

  api.post(url.BASE_SICOTEL + "event-result", siscotel);

export const createDocument = (siscotel) =>

  api.post(url.BASE_SICOTEL + "document", siscotel);



export const createMessage = (siscotel) => {

  return api.post(url.BASE_SICOTEL + "message", siscotel);

};



export const createCoverage = (siscotel) =>

  api.post(url.BASE_SICOTEL + "coverage", siscotel);



export const reenviarDiagnosticoSiscotel = (solicitudId) =>

  api.post(url.BASE_SICOTEL + `reenviar-diagnostico/${solicitudId}`);



//Farmacias

export const getFarmacias = () => api.get(url.BASE_FARMACIAS);

export const getFarmacia = (id) => api.get(url.BASE_FARMACIAS + id);

export const deleteFarmacia = (id) => api.delete(url.BASE_FARMACIAS + id + "/");

export const editFarmacia = (farmacia) =>

  api.put(url.BASE_FARMACIAS + farmacia.id, farmacia);

export const createFarmacia = (farmacia) =>

  api.post(url.BASE_FARMACIAS, farmacia);



//Plantillas Mensajes

export const getPlantillasMensajes = () => api.get(url.BASE_PLANTILLASMENSAJES);

export const getPlantillaMensaje = (id) =>

  api.get(url.BASE_PLANTILLASMENSAJES + id);

export const deletePlantillaMensaje = (id) =>

  api.delete(url.BASE_PLANTILLASMENSAJES + id + "/");

export const editPlantillaMensaje = (plantillaMensaje) =>

  api.put(

    url.BASE_PLANTILLASMENSAJES + plantillaMensaje.id + "/",

    plantillaMensaje

  );

export const createPlantillaMensaje = (plantillaMensaje) =>

  api.post(url.BASE_PLANTILLASMENSAJES, plantillaMensaje);



// Laboratorios

export const getLaboratorios = () => api.get(url.BASE_LABORATORIOS);

export const getLaboratorio = (id) => api.get(url.BASE_LABORATORIOS + "/" + id);

export const deleteLaboratorio = (id) =>

  api.delete(url.BASE_LABORATORIOS + "/" + id);

export const editLaboratorio = (laboratorio) =>

  api.put(url.BASE_LABORATORIOS + "/" + laboratorio.id, laboratorio);

export const createLaboratorio = (laboratorio) =>

  api.post(url.BASE_LABORATORIOS, laboratorio);



// Principios Activos

export const getPrincipiosActivos = () => api.get(url.BASE_PRINCIPIOSACTIVOS);

export const getPrincipioActivo = (id) =>

  api.get(url.BASE_PRINCIPIOSACTIVOS + "/" + id);

export const deletePrincipioActivo = (id) =>

  api.delete(url.BASE_PRINCIPIOSACTIVOS + id);

export const editPrincipioActivo = (principioActivo) =>

  api.put(

    url.BASE_PRINCIPIOSACTIVOS + "/" + principioActivo.id,

    principioActivo

  );

export const createPrincipioActivo = (principioActivo) =>

  api.post(url.BASE_PRINCIPIOSACTIVOS, principioActivo);



// Principios Activos Categorias

export const getPrincipiosActivosCategorias = () =>

  api.get(url.BASE_PRINCIPIOSACTIVOSCATEGORIAS);

export const getPrincipioActivoCategoria = (id) =>

  api.get(url.BASE_PRINCIPIOSACTIVOSCATEGORIAS + "/" + id);

export const deletePrincipioActivoCategoria = (id) =>

  api.delete(url.BASE_PRINCIPIOSACTIVOSCATEGORIAS + "/" + id);

export const editPrincipioActivoCategoria = (principioActivo) =>

  api.put(

    url.BASE_PRINCIPIOSACTIVOSCATEGORIAS + "/" + principioActivo.id,

    principioActivo

  );

export const createPrincipioActivoCategoria = (principioActivo) =>

  api.post(url.BASE_PRINCIPIOSACTIVOSCATEGORIAS, principioActivo);



// Usuarios

export const getUsuarios = () => api.get(url.BASE_USUARIOS);

export const getUsuario = (id) => api.get(url.BASE_USUARIOS + "/" + id);

export const deleteUsuario = (id) => api.delete(url.BASE_USUARIOS + "/" + id);

export const editUsuario = (usuario) =>

  api.put(url.BASE_USUARIOS + "/" + usuario.id, usuario);

export const createUsuario = (usuario) => api.post(url.BASE_USUARIOS, usuario);

export const resetPassword = (usuario) =>

  api.post(url.BASE_USUARIOS + "/reset-password/", usuario);



// Foto de perfil

export const uploadFotoPerfil = (imagenBase64) =>

  api.post(url.BASE_USUARIOS + "/foto-perfil", { imagen_base64: imagenBase64 });

export const getFotoPerfil = () =>

  api.get(url.BASE_USUARIOS + "/foto-perfil");

export const deleteFotoPerfil = () =>

  api.delete(url.BASE_USUARIOS + "/foto-perfil");



// Foto de perfil por ID (para CRUD de usuarios)

export const uploadFotoPerfilById = (id, imagenBase64) =>

  api.post(url.BASE_USUARIOS + "/foto-perfil/" + id, { imagen_base64: imagenBase64 });

export const deleteFotoPerfilById = (id) =>

  api.delete(url.BASE_USUARIOS + "/foto-perfil/" + id);



// Logo de farmacia

export const uploadLogoFarmacia = (id, imagenBase64) =>

  api.post(url.BASE_FARMACIAS + "logo/" + id, { imagen_base64: imagenBase64 });

export const deleteLogoFarmacia = (id) =>

  api.delete(url.BASE_FARMACIAS + "logo/" + id);

export const getFarmaciaPorCodigo = (codigo) =>

  api.get(url.BASE_FARMACIAS + "por-codigo/" + codigo);



// Servicios de Entrega

export const getServiciosDeEntregas = () =>

  api.get(url.BASE_SERVICIODEENTREGAS);

export const getServicioDeEntrega = (id) =>

  api.get(url.BASE_SERVICIODEENTREGAS + "/" + id);

export const deleteServicioDeEntrega = (id) =>

  api.delete(url.BASE_SERVICIODEENTREGAS + "/" + id);

export const editServicioDeEntrega = (ServicioDeEntrega) =>

  api.put(

    url.BASE_SERVICIODEENTREGAS + "/" + ServicioDeEntrega.id,

    ServicioDeEntrega

  );

export const createServicioDeEntrega = (ServicioDeEntrega) =>

  api.post(url.BASE_SERVICIODEENTREGAS, ServicioDeEntrega);



// Planilla Estratégica

export const getPlanillasEstrategicas = () =>

  api.get(url.BASE_PLANILLAESTRATEGICA);

export const getPlanillaEstrategica = (id) =>

  api.get(url.BASE_PLANILLAESTRATEGICA + "/" + id);

export const deletePlanillaEstrategica = (id) =>

  api.delete(url.BASE_PLANILLAESTRATEGICA + "/" + id);

export const editPlanillaEstrategica = (planillaEstrategica) =>

  api.put(

    url.BASE_PLANILLAESTRATEGICA + "/" + planillaEstrategica.id,

    planillaEstrategica

  );

export const createPlanillaEstrategica = (planillaEstrategica) =>

  api.post(url.BASE_PLANILLAESTRATEGICA, planillaEstrategica);



// Solicitudes

export const getsolicitudes = (query) =>

  api.get(url.BASE_SOLICITUDES + "/?" + query);

export const getsolicitud = (id) => api.get(url.BASE_SOLICITUDES + "/" + id);

export const deletesolicitud = (id) =>

  api.delete(url.BASE_SOLICITUDES + "/" + id);

export const editsolicitud = (solicitud) =>

  api.put(url.BASE_SOLICITUDES + "/" + solicitud.id + "/", solicitud);

export const updateSolicitudStatus = (statusUpdate) =>

  api.put(url.BASE_SOLICITUDES + "/solicitudes/status/", statusUpdate);

export const aceptarSolicitud = (identificador) =>

  api.post(url.BASE_SOLICITUDES + "/solicitudes/" + identificador + "/aceptar");

export const createsolicitud = (solicitud) =>

  api.post(url.BASE_SOLICITUDES, solicitud);

export const createSolicitudManual = (payload) =>
  api.post("/api/v1/solicitudes/manual", payload);

export const medicamentos = (lista) =>

  api.post(url.BASE_SOLICITUDES + "/medicamentos/", lista);

export const rutaOptima = (data) =>

  api.post(url.BASE_SOLICITUDES + "/ruta-optima/", {

    solicitudes_ids: data.solicitudes_ids,

    ruta_id: data.ruta_id,

  });

export const verificarDocumentosSolicitud = (solicitudId, verificacion) =>

  api.put(url.BASE_SOLICITUDES + "/" + solicitudId + "/verificar-documentos", verificacion);

export const verificarDireccionSolicitud = (solicitudId, verificacion) =>

  api.put(url.BASE_SOLICITUDES + "/" + solicitudId + "/verificar-direccion", verificacion);

export const solicitudesEntregar = (id_user) => {

  return api.get(url.BASE_SOLICITUDES + "/solicitudes-entregar/" + id_user);

};

export const updateDeliverySolicitud = (solicitud) =>

  api.put(

    `${url.BASE_SOLICITUDES}/${solicitud.identificador}/delivery/`,

    solicitud

  );

  

export const agregarComentario = async (identificador, comentario) => {

  // Convertir identificador a string para asegurar consistencia

  const idString = String(identificador);



  try {

    const response = await api.post(

      url.BASE_SOLICITUDES + `/agregar-comentario/?identificador=${idString}`,

      comentario

    );

    return response;

  } catch (error) {

    // Si hay un error de respuesta, extraer los detalles

    if (error.response && error.response.data) {

      console.error("Detalles del error:", error.response.data);

      throw error.response.data;

    }

    // Para otros errores, lanzar un objeto serializable

    throw {

      status: error.response ? error.response.status : 500,

      message: error.message || "Error desconocido al agregar comentario",

      detail: error.response ? error.response.data : null,

    };

  }

};





export const agregarFacturacion = async (identificador, facturacion) => {

  // Convertir identificador a string para asegurar consistencia

  const idString = String(identificador);



  try {

    const response = await api.post(

      url.BASE_SOLICITUDES + `/agregar-facturacion/`,

      { 

        identificador: idString,

        facturacionArray: facturacion 

      }

    );

    return response;

  } catch (error) {

    // Si hay un error de respuesta, extraer los detalles

    if (error.response && error.response.data) {

      console.error("Detalles del error:", error.response.data);

      throw error.response.data;

    }

    // Para otros errores, lanzar un objeto serializable

    throw {

      status: error.response ? error.response.status : 500,

      message: error.message || "Error desconocido al agregar facturación",

      detail: error.response ? error.response.data : null,

    };

  }

};



export const agregarDelivery = async (identificador, delivery) => {

  // Convertir identificador a string para asegurar consistencia

  const idString = String(identificador);



  try {

    const response = await api.post(

      url.BASE_SOLICITUDES + `/agregar-delivery/?identificador=${idString}`,

      delivery

    );

    return response;

  } catch (error) {

    // Si hay un error de respuesta, extraer los detalles

    if (error.response && error.response.data) {

      console.error("Detalles del error:", error.response.data);

      throw error.response.data;

    }

    // Para otros errores, lanzar un objeto serializable

    throw {

      status: error.response ? error.response.status : 500,

      message: error.message || "Error desconocido al agregar facturación",

      detail: error.response ? error.response.data : null,

    };

  }

};



// Reportes

export const getSolicitudesPorTipo = (params) => {

  // Formatear las fechas correctamente

  const formattedParams = {

    tipo: params.tipo || "",

    farmacia: params.farmacia || "",

    estatus: params.estatus || "",

    aseguradora: params.aseguradora || "",

    fecha_inicio: params.fecha_inicio

      ? new Date(params.fecha_inicio).toISOString().split("T")[0]

      : "",

    fecha_fin: params.fecha_fin

      ? new Date(params.fecha_fin).toISOString().split("T")[0]

      : "",

  };



  const queryParams = new URLSearchParams(formattedParams).toString();

  return api.get(

    `${url.BASE_SOLICITUDES}/reportes/solicitudes-por-tipo/?${queryParams}`

  );

};



export const exportarSolicitudesPorTipo = (params) => {

  // Construir parámetros solo con valores válidos

  const queryParamsObj = {

    tipo: params.tipo || "Todas",

  };

  

  // Solo agregar parámetros si tienen valores

  if (params.farmacia) {

    queryParamsObj.farmacia = params.farmacia;

  }

  

  if (params.estatus) {

    queryParamsObj.estatus = params.estatus;

  }

  

  if (params.fecha_inicio) {

    queryParamsObj.fecha_inicio = params.fecha_inicio;

  }

  

  if (params.fecha_fin) {

    queryParamsObj.fecha_fin = params.fecha_fin;

  }

  

  // Agregar búsqueda si existe

  if (params.query) {

    queryParamsObj.query = params.query;

  }

  

  // Agregar estado geográfico si existe

  if (params.estadoGeografico) {

    queryParamsObj.estadoGeografico = params.estadoGeografico;

  }

  

  // Agregar aseguradora si existe

  if (params.aseguradora) {

    queryParamsObj.aseguradora = params.aseguradora;

  }

  

  const queryParams = new URLSearchParams(queryParamsObj).toString();



  return api.getBlob(

    `${url.BASE_SOLICITUDES}/reportes/solicitudes-por-tipo/exportar/?${queryParams}`

  );

};



export const downloadBlob = (blob, fileName) => {

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");

  a.style.display = "none";

  a.href = url;

  a.download = fileName;

  document.body.appendChild(a);

  a.click();

  window.URL.revokeObjectURL(url);

  document.body.removeChild(a);

};



export const getFacturacionPorPeriodo = (params) => {

  // Formatear las fechas correctamente

  const formattedParams = {

    tipo: params.tipo || "",

    farmacia: params.farmacia || "",

    estatus: params.estatus || "",

    estatus_pago: params.estatus_pago || "",

    aseguradora: params.aseguradora || "",

    fecha_inicio: params.fecha_inicio

      ? new Date(params.fecha_inicio).toISOString().split("T")[0]

      : "",

    fecha_fin: params.fecha_fin

      ? new Date(params.fecha_fin).toISOString().split("T")[0]

      : "",

  };



  const queryParams = new URLSearchParams(formattedParams).toString();

  return api.get(

    `${url.BASE_SOLICITUDES}/reportes/facturacion-por-periodo/?${queryParams}`

  );

};



export const exportarFacturacionPorPeriodo = (params) => {

  const queryParams = new URLSearchParams({

    tipo: params.tipo || "Todas",

    farmacia: params.farmacia || "",

    estatus: params.estatus || "",

    estatus_pago: params.estatus_pago || "",

    aseguradora: params.aseguradora || "",

    estado_geografico: params.estado_geografico || "",

    fecha_inicio: params.fecha_inicio

      ? new Date(params.fecha_inicio).toISOString().split("T")[0]

      : "",

    fecha_fin: params.fecha_fin

      ? new Date(params.fecha_fin).toISOString().split("T")[0]

      : "",

  }).toString();



  return api.getBlob(

    `${url.BASE_SOLICITUDES}/reportes/facturacion-por-periodo/exportar/?${queryParams}`

  );

};



export const getSolicitudesFacturacion = (params) => {

  return api.get(

    `${url.BASE_SOLICITUDES}/verificarqr/${params.id}/${params.factura}`

  );

};



export const getSolicitudesFacturacionPublic = (params) => {

  // Crear una instancia de axios que no incluya el token de autenticación

  const publicApi = axios.create({

    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',

    timeout: 30000,

  });

  

  // Asegurar que el ID y la factura estén en el formato correcto

  const id = params.id ? params.id.toString() : '';

  const factura = params.factura ? params.factura.toString() : '';

  

  const url = `/solicitud/verificarqr/${id}/${factura}`;

  return publicApi.get(url)

    .then(response => {

      

      // Asegurarnos de que la estructura de la respuesta coincida con lo que espera el reducer

      if (response && response.data) {

        // La respuesta del backend tiene la estructura:

        // { data: {...}, status_code: 200, message: "..." }

        // Pero el reducer espera:

        // { data: { data: {...} }, message: "..." }

        return {

          data: {

            data: response.data.data

          },

          message: response.data.message,

          status: response.status

        };

      }

      return response;

    })

    .catch(error => {

      console.error("VerificarQR - Error en la solicitud:", error);

      console.error("VerificarQR - Detalles del error:", error.response ? error.response.data : 'No hay detalles');

      throw error;

    });

};



export const enviarFeedbackQRPublic = (id, factura, payload) => {

  const publicApi = axios.create({

    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',

    timeout: 30000,

  });

  const safeId = id ? id.toString() : '';

  const safeFactura = factura ? factura.toString() : '';

  return publicApi.post(`/solicitud/feedbackqr/${safeId}/${safeFactura}`, payload);

};



// Rutas

/* export const optimizarRuta = (data) => api.post("/rutas/optimizar", data); */



export const crearRuta = async (data) => {

  try {

    const response = await api.post("/rutas", data);

    return response;

  } catch (error) {

    console.error("Error al crear ruta:", error);

    // Rethrow para que el error se maneje en el nivel superior

    throw error;

  }

};



export const actualizarRuta = (datos) => {

  return api.put(`/rutas/${datos.id}`, datos);

};



export const actualizarEstadoSolicitudEnRuta = async (

  rutaId,

  solicitudId,

  datos

) => {

  try {

    // Verificar que al menos solicitudId sea válido

    if (!solicitudId) {

      console.error(

        "Parámetros inválidos para actualizarEstadoSolicitudEnRuta:",

        { rutaId, solicitudId, datos }

      );

      throw new Error(

        "Parámetros inválidos para actualizar estado de solicitud"

      );

    }



    if (typeof datos === "object" && datos !== null) {

      try {

        // Crear un objeto completo para el endpoint de solicitudes

        const solicitudUpdate = datos;

        // Construir la URL para el endpoint de solicitudes

        const url = `/solicitud/${datos.identificador}/delivery/`;

        // Realizar la solicitud PUT con el body completo

        const response = await api.put(url, solicitudUpdate);



        // También actualizar el estado en la ruta para mantener la consistencia (solo si hay ruta)

        if (rutaId) {

          try {

            const rutaUrl = `/rutas/${rutaId}/solicitud/${solicitudId}?estado=${

              datos.estatusDelivery === "Entregado" ? "ENTREGADO" : "CANCELADO"

            }`;

            const rutaResponse = await api.put(rutaUrl);

          } catch (rutaError) {

            console.error(

              "Error al actualizar el estado en la ruta, pero la solicitud se actualizó correctamente:",

              rutaError

            );

            // No lanzamos el error aquí, ya que la actualización principal (solicitud) fue exitosa

          }

        }



        return { success: true, data: response };

      } catch (solicitudError) {

        console.error(

          "Error al actualizar la solicitud de delivery:",

          solicitudError

        );

      }

    } else {

      throw new Error(

        "Formato de datos inválido para actualizar estado de solicitud"

      );

    }

  } catch (error) {

    console.error("Error al actualizar estado de solicitud en ruta:", error);

    return {

      success: false,

      error:

        error.message || "Error desconocido al actualizar estado de solicitud",

      details: error,

    };

  }

};



export const finalizarRuta = async (rutaId) => {

  try {

    // Verificar que el parámetro sea válido

    if (!rutaId) {

      console.error("Parámetro inválido para finalizarRuta:", { rutaId });

      throw new Error("Parámetro inválido para finalizar ruta");

    }



    // Construir la URL correctamente según el endpoint del backend

    // El endpoint en el backend es @router.put("/finalizar/{ruta_id}")

    // El router tiene el prefijo "/rutas"

    const url = `/rutas/finalizar/${rutaId}`;



    const response = await api.put(url);

    return response;

  } catch (error) {

    console.error("Error al finalizar ruta:", error);

    throw error;

  }

};



export const obtenerRutaActiva = (motorizadoId) => {

  return api.get(`/rutas/activa/${motorizadoId}`);

};



export const obtenerEstadisticasRuta = (motorizadoId, params) =>

  api.get(`/rutas/estadisticas/${motorizadoId}`, { params });



//Dashboard

export const getKpis = (params) => {

  // Formatear las fechas correctamente

  const formattedParams = {

    fecha_inicio: params.fecha_inicio

      ? new Date(params.fecha_inicio).toISOString().split("T")[0]

      : "",

    fecha_fin: params.fecha_fin

      ? new Date(params.fecha_fin).toISOString().split("T")[0]

      : "",

    codigo_proveedor: params.codigo_proveedor || null,

  };

  // Agregar aseguradora si existe
  if (params.aseguradora) {
    formattedParams.aseguradora = params.aseguradora;
  }



  const queryParams = new URLSearchParams(formattedParams).toString();



  return api.get(`/api/v1/dashboard/kpis?${queryParams}`);

};



// Archivos - URLs prefirmadas (Tickets)

export const getUrlPrefirmadaTicket = (ticketId, nombreArchivo, expiracion = 3600) =>
  api.get(`/api/v1/tickets/adjuntos/${ticketId}/${encodeURIComponent(nombreArchivo)}?expiracion=${expiracion}`);

// Archivos - URLs prefirmadas

export const getUrlPrefirmada = (fileUrl, expiracion = 3600) => 

  api.get(`/solicitud/archivos/url-prefirmada?url=${encodeURIComponent(fileUrl)}&expiracion=${expiracion}`);



// Versión pública para obtener URLs prefirmadas (sin autenticación)

export const getUrlPrefirmadaPublic = (fileUrl, expiracion = 3600) => {

  // Crear una instancia de axios que no incluya el token de autenticación

  const publicApi = axios.create({

    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',

    timeout: 30000,

  });

  

  // Corregir la URL para que coincida con el endpoint del backend

  const url = `/solicitud/archivos/url-prefirmada?url=${encodeURIComponent(fileUrl)}&expiracion=${expiracion}`;

  

  return publicApi.get(url)

    .then(response => {

      

      // Asegurarnos de que la estructura de la respuesta sea consistente

      if (response && response.data) {

        return {

          data: response.data,

          status: response.status

        };

      }

      return response;

    })

    .catch(error => {

      console.error("VerificarQR - Error al obtener URL prefirmada:", error);

      console.error("VerificarQR - Detalles del error:", error.response ? error.response.data : 'No hay detalles');

      throw error;

    });

};



// Dashboard Widgets

/**

 * Obtiene diagnósticos farmacológicos para el dashboard

 * @param {Object} params - Parámetros de consulta

 * @returns {Promise} - Respuesta del backend con diagnósticos

 */

export const getDiagnosticosFarmacologicos = async (params) => {

  const queryParams = new URLSearchParams({

    fecha_inicio: params.fecha_inicio || "",

    fecha_fin: params.fecha_fin || "",

    top: params.top || 5

  });



  if (params.codigo_proveedor && params.codigo_proveedor.trim() !== "") {

    queryParams.append("codigo_proveedor", params.codigo_proveedor);

  }

  if (params.aseguradora) {

    queryParams.append("aseguradora", params.aseguradora);

  }



  const response = await api.get(`/api/v1/dashboard/diagnosticos-farmacologicos?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene rendimiento de motorizados para el dashboard

 * @param {Object} params - Parámetros de consulta

 * @returns {Promise} - Respuesta del backend con rendimiento

 */

export const getRendimientoMotorizados = async (params) => {

  const queryParams = new URLSearchParams({

    fecha_inicio: params.fecha_inicio || "",

    fecha_fin: params.fecha_fin || "",

    top: params.top || 5

  });



  if (params.codigo_proveedor && params.codigo_proveedor.trim() !== "") {

    queryParams.append("codigo_proveedor", params.codigo_proveedor);

  }

  if (params.aseguradora) {

    queryParams.append("aseguradora", params.aseguradora);

  }



  const response = await api.get(`/api/v1/dashboard/rendimiento-motorizados?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene promedio de facturación para el dashboard (gráfico de tendencias)

 * @param {Object} params - Parámetros de consulta

 * @returns {Promise} - Respuesta del backend con datos de tendencias

 */

export const getPromedioFacturacion = async (params) => {

  const queryParams = new URLSearchParams();

  

  if (params.fecha_inicio) queryParams.append("fecha_inicio", params.fecha_inicio);

  if (params.fecha_fin) queryParams.append("fecha_fin", params.fecha_fin);

  if (params.agrupacion) queryParams.append("agrupacion", params.agrupacion);

  if (params.tipo_solicitud) queryParams.append("tipo_solicitud", params.tipo_solicitud);

  if (params.codigo_proveedor && params.codigo_proveedor.trim() !== "") {

    queryParams.append("codigo_proveedor", params.codigo_proveedor);

  }

  if (params.aseguradora) {

    queryParams.append("aseguradora", params.aseguradora);

  }



  const response = await api.get(`/api/v1/dashboard/promedio-facturacion?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene la cantidad de solicitudes creadas agrupadas por período

 * @param {Object} params - Parámetros de consulta

 * @param {string} params.fecha_inicio - Fecha de inicio (YYYY-MM-DD)

 * @param {string} params.fecha_fin - Fecha de fin (YYYY-MM-DD)

 * @param {string} params.agrupacion - Tipo de agrupación (dia, semana, mes)

 * @param {string} params.tipo_solicitud - Tipo de solicitud (total, Cronica, Aguda)

 * @param {string} params.codigo_proveedor - Código del proveedor (opcional)

 * @param {string} params.aseguradora - Aseguradora (opcional)

 * @returns {Promise} - Respuesta del backend con datos de solicitudes creadas

 */

export const getSolicitudesCreadas = async (params) => {

  const queryParams = new URLSearchParams();

  if (params.fecha_inicio) queryParams.append("fecha_inicio", params.fecha_inicio);

  if (params.fecha_fin) queryParams.append("fecha_fin", params.fecha_fin);

  if (params.agrupacion) queryParams.append("agrupacion", params.agrupacion);

  if (params.tipo_solicitud) queryParams.append("tipo_solicitud", params.tipo_solicitud);

  if (params.codigo_proveedor && params.codigo_proveedor.trim() !== "") {

    queryParams.append("codigo_proveedor", params.codigo_proveedor);

  }

  if (params.aseguradora) {

    queryParams.append("aseguradora", params.aseguradora);

  }

  const response = await api.get(`/api/v1/dashboard/solicitudes-creadas?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene la lista de proveedores para el dashboard

 * @returns {Promise} - Respuesta del backend con lista de proveedores

 */

export const getProveedoresDashboard = async () => {

  const response = await api.get(`/api/v1/dashboard/proveedores`);

  return response;

};



/**

 * Obtiene tendencia histórica de una métrica

 * @param {string} metrica - Nombre de la métrica

 * @param {Object} params - Parámetros de consulta (agrupacion, codigo_proveedor)

 * @returns {Promise} - Respuesta del backend con tendencia

 */

export const getTendenciaHistorica = async (metrica, params = {}) => {

  const queryParams = new URLSearchParams();

  if (params.agrupacion) queryParams.append("agrupacion", params.agrupacion);

  if (params.codigo_proveedor) queryParams.append("codigo_proveedor", params.codigo_proveedor);

  if (params.aseguradora) queryParams.append("aseguradora", params.aseguradora);


  const response = await api.get(`/api/v1/dashboard/tendencia-historica/${metrica}?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene KPIs históricos del dashboard

 * @param {Object} params - Parámetros de consulta (codigo_proveedor)

 * @returns {Promise} - Respuesta del backend con KPIs históricos

 */

export const getKpisHistoricos = async (params = {}) => {

  const queryParams = new URLSearchParams();

  if (params.codigo_proveedor && params.codigo_proveedor !== 'GLOBAL') {

    queryParams.append("codigo_proveedor", params.codigo_proveedor);

  }

  if (params.aseguradora) {

    queryParams.append("aseguradora", params.aseguradora);

  }

  

  const response = await api.get(`/api/v1/dashboard/kpis-historicos?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene comparativa de proveedores para el dashboard

 * @param {Object} params - Parámetros de consulta

 * @returns {Promise} - Respuesta del backend con comparativa

 */

export const getComparativaProveedores = async (params) => {

  const queryParams = new URLSearchParams({

    fecha_inicio: params.fecha_inicio || "",

    fecha_fin: params.fecha_fin || ""

  });



  if (params.codigo_proveedor && params.codigo_proveedor.trim() !== "") {

    queryParams.append("codigo_proveedor", params.codigo_proveedor);

  }

  if (params.aseguradora) {

    queryParams.append("aseguradora", params.aseguradora);

  }



  const response = await api.get(`/api/v1/dashboard/comparativa-proveedores?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene facturas outliers de un proveedor (método IQR)

 * @param {string} codigoProveedor - Código del proveedor

 * @param {Object} params - Parámetros de consulta (fecha_inicio, fecha_fin)

 * @returns {Promise} - Respuesta del backend con facturas outliers

 */

export const getOutliersFacturas = async (codigoProveedor, params = {}) => {

  const queryParams = new URLSearchParams();

  if (params.fecha_inicio) queryParams.append("fecha_inicio", params.fecha_inicio);

  if (params.fecha_fin) queryParams.append("fecha_fin", params.fecha_fin);

  if (params.aseguradora) queryParams.append("aseguradora", params.aseguradora);


  const response = await api.get(`/api/v1/dashboard/outliers-facturas/${codigoProveedor}?${queryParams.toString()}`);

  return response;

};



/**

 * Obtiene facturas outliers de un proveedor (método desviación estándar)

 * @param {string} codigoProveedor - Código del proveedor

 * @param {Object} params - Parámetros de consulta (fecha_inicio, fecha_fin)

 * @returns {Promise} - Respuesta del backend con facturas outliers

 */

export const getOutliersDesviacionFacturas = async (codigoProveedor, params = {}) => {

  const queryParams = new URLSearchParams();

  if (params.fecha_inicio) queryParams.append("fecha_inicio", params.fecha_inicio);

  if (params.fecha_fin) queryParams.append("fecha_fin", params.fecha_fin);

  if (params.aseguradora) queryParams.append("aseguradora", params.aseguradora);


  const response = await api.get(`/api/v1/dashboard/outliers-facturas-desviacion/${codigoProveedor}?${queryParams.toString()}`);

  return response;

};



// Facturas IA

/**

 * Valida una imagen de factura en el backend

 * @param {FormData} formData - FormData con la imagen

 * @returns {Promise} - Respuesta del backend con validación y corrección

 */

export const validarFacturaIA = async (formData) => {

  const response = await api.post(url.BASE_FACTURAS_IA + "validar-imagen", formData, {

    headers: {

      'Content-Type': 'multipart/form-data'

    }

  });

  return response.data;

};



/**

 * Extrae datos de una factura usando OCR + IA

 * @param {FormData} formData - FormData con la imagen

 * @returns {Promise} - Respuesta del backend con datos extraídos

 */

export const extraerDatosFacturaIA = async (formData) => {

  const response = await api.post(url.BASE_FACTURAS_IA + "extraer-datos", formData, {

    headers: {

      'Content-Type': 'multipart/form-data'

    }

  });

  return response.data;

};



// Layout Dashboard

/**

 * Guarda el layout del dashboard de un usuario

 * @param {string} codigoFarmacia - Identificador del usuario/farmacia

 * @param {Array} layout - Configuración del layout

 * @returns {Promise} - Respuesta del backend

 */

export const guardarLayoutDashboard = async (codigoFarmacia, layout) => {

  const response = await api.post(`/usuarios/layout-dashboard`, {

    codigo_farmacia: codigoFarmacia,

    layout: layout

  });

  return response;

};



/**

 * Obtiene el layout del dashboard de un usuario

 * @param {string} codigoFarmacia - Identificador del usuario/farmacia

 * @returns {Promise} - Respuesta del backend con el layout

 */

export const getLayoutDashboard = async (codigoFarmacia) => {

  const response = await api.get(`/usuarios/layout-dashboard`, { params: { codigo_farmacia: codigoFarmacia } });

  return response;

};



// Reportes

/**

 * Obtiene el reporte de notificaciones SISCOTEL pendientes

 * @param {Object} params - Parámetros de filtro (fecha_inicio, fecha_fin, codigo_proveedor)

 * @returns {Promise} - Respuesta del backend con solicitudes pendientes

 */

export const getReporteSiscotelPendientes = (params) => {
  // Construir query string manualmente para evitar anidación params[...]
  const queryParams = new URLSearchParams();
  
  if (params.fecha_inicio) {
    queryParams.append('fecha_inicio', params.fecha_inicio);
  }
  if (params.fecha_fin) {
    queryParams.append('fecha_fin', params.fecha_fin);
  }
  if (params.codigo_proveedor) {
    queryParams.append('codigo_proveedor', params.codigo_proveedor);
  }
  if (params.aseguradora) {
    queryParams.append('aseguradora', params.aseguradora);
  }

  const requestUrl = `${url.REPORTES_SISCOTEL_PENDIENTES}?${queryParams.toString()}`;
  return api.get(requestUrl);
};

// Reenvío manual de notificaciones Siscotel
export const reenviarNotificacionSiscotelManual = (solicitudes) => {
  return api.post(url.SISCOTEL_REENVIAR_NOTIFICACION, { solicitudes });
};

// Plantas
/**
 * Obtiene todas las plantas

 * @param {Object} params - Parámetros de filtro (estado, solo_activas)

 * @returns {Promise} - Respuesta del backend con lista de plantas

 */

export const getPlantas = (params) => api.get(url.BASE_PLANTAS, params);



/**

 * Obtiene una planta por ID

 * @param {string} id - ID de la planta

 * @returns {Promise} - Respuesta del backend con la planta

 */

export const getPlanta = (id) => api.get(url.BASE_PLANTAS + id);



/**

 * Crea una nueva planta

 * @param {Object} planta - Datos de la planta

 * @returns {Promise} - Respuesta del backend con la planta creada

 */

export const createPlanta = (planta) => api.post(url.BASE_PLANTAS, planta);



/**

 * Actualiza una planta existente

 * @param {string} id - ID de la planta

 * @param {Object} planta - Datos actualizados de la planta

 * @returns {Promise} - Respuesta del backend con la planta actualizada

 */

export const updatePlanta = (id, planta) => api.put(url.BASE_PLANTAS + id, planta);



/**

 * Elimina (desactiva) una planta

 * @param {string} id - ID de la planta

 * @returns {Promise} - Respuesta del backend confirmando la eliminación

 */

export const deletePlanta = (id) => api.delete(url.BASE_PLANTAS + id);



/**

 * Asigna una solicitud a una planta

 * @param {string} solicitudId - ID de la solicitud

 * @param {Object} data - Datos de asignación (planta_id, confirmado)

 * @returns {Promise} - Respuesta del backend con la solicitud actualizada

 */

export const asignarSolicitudAPlanta = (solicitudId, data) => 

  api.put(`/api/v1/solicitudes/${solicitudId}/asignar-planta`, data);



/**

 * Remueve la asignación de planta de una solicitud

 * @param {string} solicitudId - ID de la solicitud

 * @returns {Promise} - Respuesta del backend con la solicitud actualizada

 */

export const removerPlantaDeSolicitud = (solicitudId) => 

  api.put(`/api/v1/solicitudes/${solicitudId}/remover-planta`, {});



/**

 * Obtiene reporte detallado de entregas en plantas

 * @param {Object} params - Parámetros de filtro (planta_id, estado, estatus, fecha_desde, fecha_hasta)

 * @returns {Promise} - Respuesta del backend con reporte detallado

 */

export const getReporteEntregasPlantas = (params) =>

  api.get(url.REPORTES_ENTREGAS_PLANTAS, params);



/**

 * Obtiene resumen general de entregas en plantas

 * @returns {Promise} - Respuesta del backend con resumen

 */

export const getResumenEntregasPlantas = () =>

  api.get(url.REPORTES_ENTREGAS_PLANTAS_RESUMEN);



/**

 * Obtiene la tasa del dólar actual

 * @returns {Promise} - Respuesta del backend con la tasa del dólar

 */

export const getTasaDolar = () => api.get(url.BASE_TASA_DOLAR);

export const buscarPorCedula = (cedula) =>
  api.get(`/api/v1/solicitudes/buscar-por-cedula?cedula=${encodeURIComponent(cedula)}`);

export const uploadSolicitudFile = async (identificador, tipoArchivo, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(
    `/solicitud/upload-file/${encodeURIComponent(identificador)}/${tipoArchivo}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

// Validación de factura única
export const validarFacturaUnica = (data) =>
  api.post("/solicitud/validar-factura", data);

/**
 * Obtiene solicitudes de Seguros Mercantil con estatus "Nueva Solicitud"
 * para comparación con CSV
 * @param {Object} params - Parámetros de consulta (fecha, solo_nuevas)
 * @returns {Promise} - Respuesta del backend con solicitudes
 */
export const getSolicitudesMercantilNuevas = (params) => {
  const queryParams = new URLSearchParams({
    solo_nuevas: params.solo_nuevas !== false ? "true" : "false",
  });
  
  // Soportar tanto fecha única como rango
  if (params.fecha) {
    queryParams.append("fecha", params.fecha);
  } else if (params.fecha_inicio && params.fecha_fin) {
    queryParams.append("fecha_inicio", params.fecha_inicio);
    queryParams.append("fecha_fin", params.fecha_fin);
  }

  return api.get(`/solicitud/mercantil/nuevas?${queryParams.toString()}`);
};

// Mercantil Scraping

export const mercantilScrapingRun = (body = {}) =>
  api.post(url.MERCANTIL_SCRAPING_RUN, body);

export const mercantilScrapingGetRun = (runId) =>
  api.get(`${url.MERCANTIL_SCRAPING_RUNS}/${encodeURIComponent(runId)}`);

export const mercantilScrapingStatus = () =>
  api.get(url.MERCANTIL_SCRAPING_STATUS);

export const mercantilBuscarYRegistrar = (identificador) =>
  api.post(`${url.MERCANTIL_BUSCAR_REGISTRAR}/${encodeURIComponent(identificador)}`);

export const mercantilScrapingListRuns = ({ limit = 20, skip = 0 } = {}) => {
  const qs = new URLSearchParams({ limit: String(limit), skip: String(skip) });
  return api.get(`${url.MERCANTIL_SCRAPING_RUNS}?${qs.toString()}`);
};

export const mercantilScrapingRetry = (identificador, runId = null) => {
  const path = `${url.MERCANTIL_SCRAPING_RETRY}/${encodeURIComponent(identificador)}`;
  const qs = runId ? `?run_id=${encodeURIComponent(runId)}` : "";
  return api.post(`${path}${qs}`);
};

export const mercantilScrapingMarcarRevision = (runId, identificador, { estado, nota = null } = {}) => {
  const path = `${url.MERCANTIL_SCRAPING_RUNS}/${encodeURIComponent(runId)}/ordenes/${encodeURIComponent(identificador)}/revision`;
  return api.patch(path, { estado, nota });
};
